export const SET_AUDIT_SHOP = 'SET_AUDIT_SHOP'
export const SET_AUDIT_SHOP_FIELD_VALUES = 'SET_AUDIT_SHOP_FIELD_VALUES'
export const SET_AUDIT_SHOP_SCHEMA = 'SET_AUDIT_SHOP_SCHEMA'
export const RESET_STATE = 'RESET_STATE'
